export class LogoutService {
  isConnected = false;

  onDisconnect(): any {
    sessionStorage.clear();
    this.isConnected = false;
  }
}
